<template>
  <Form ref="quotesGroupForm" :model="formData">
    <Row :gutter="32" class="align-items-center">
      <Col span="24">
        <FormItem :label="$t('quote.info.title')" prop="title" :rules="{ required: true, message: $t('quote.title_is_required') }">
          <Input v-model="formData.title"></Input>
        </FormItem>
      </Col>
    </Row>
    <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('quote.info.product')" prop="product_id" :rules="{ required: true, message: $t('quote.customer_is_required') }">
            <ProductSelect v-model="formData.product_id" v-bind:product.sync="formData.product"></ProductSelect>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('quote.info.expires_date')" prop="expires_at" :rules="{ required: true, message: $t('quote.expires_date_is_required') }">
            <DatePicker v-model="formData.expires_at" @on-change="handleExpiresDateChange" type="date" format="yyyy-MM-dd" transfer></DatePicker>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('quote.info.customer')" prop="customer_id" :rules="{ required: true, message: $t('quote.customer_is_required') }">
            <AccountSearchAndPickWidget v-model="formData.customer_id" v-bind:account.sync="formData.customer"></AccountSearchAndPickWidget>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32" class="align-items-center">
        <Col span="6">
          <FormItem :label="$t('quote.info.currency')" prop="currency" :rules="{ required: true, message: $t('quote.currency_is_required') }">
            <CurrencySelect :value.sync="formData.currency"></CurrencySelect>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem class="hasDesc" :label="$t('exchange_rate')" prop="exchange_rate">
            <InputNumber v-model="formData.exchange_rate"></InputNumber>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('quote.info.trade_type')" prop="trade_type" :rules="{ required: true, message: $t('quote.trade_type_is_required') }" required>
            <QuoteTradeTypeSelect v-model="formData.trade_type"></QuoteTradeTypeSelect>
          </FormItem>
        </Col>
        <Col span="6">
          <FormItem :label="$t('quote.info.status')" prop="status" :rules="{ required: true, message: $t('quote.status_is_required') }" required>
            <Select v-model="formData.status">
              <Option value="activated">{{ $t('quote.group_status_activated') }}</Option>
              <Option value="draft">{{ $t('quote.group_status_drafting') }}</Option>
              <Option value="closed">{{ $t('quote.group_status_closed') }}</Option>
              <Option value="invalidated">{{ $t('quote.group_status_invalidated') }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('quote.info.owner')" prop="people_id" :rules="{ required: true, message: $t('quote.owner_is_required') }">
            <PeopleSelect v-model="formData.people_id" v-bind:people.sync="formData.people" :placeholder="$t('quote.find_people_placeholder')"></PeopleSelect>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32" class="align-items-center">
        <Col span="24">
          <FormItem :label="$t('quote.info.remark')">
            <Input v-model="formData.remark" type="textarea" :rows="8"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32" class="align-items-center">
        <Col span="24">
          <div class="text-align-right actions">
            <Button type="primary" :loading="loading" @click="handleSubmit('quoteForm')" size="large">{{ $t('save') }}</Button>
          </div>
        </Col>
      </Row>
  </Form>
</template>

<script>
import { QuoteTradeTypeSelect } from '../form-controls'
import { PercentInputNumber } from '@/components/nexpcb'
import AccountSearchAndPickWidget from '@/view/account/components/widgets/account-search-and-pick-widget.vue'
import ProductSelect from '@/view/product/components/product-select'
import CurrencySelect from '@/components/currency'
import { PeopleSelect } from '@/view/people/components'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'QuotesGroupForm',
  components: {
    ProductSelect,
    PercentInputNumber,
    AccountSearchAndPickWidget,
    QuoteTradeTypeSelect,
    CurrencySelect,
    PeopleSelect
  },
  props: {
    quoteGroupInstance: {
      type: Object,
      requried: false
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      formData: {
        status: 'draft'
      }
    }
  },
  mounted () {
    if (this.quoteGroupInstance) {
      this.formData = _.cloneDeep(this.quoteGroupInstance)
    }
  },
  methods: {
    ...mapActions([
      'createQuoteGroup',
      'updateQuoteGroup'
    ]),
    moment,
    handleExpiresDateChange (date) {
      this.formData.expires_at = date
    },
    handleSubmit () {
      let data = _.cloneDeep(this.formData)
      this.$refs['quotesGroupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          data['expires_at'] = moment(data['expires_at']).format('YYYY-MM-DD')
          if (!this.formData.id) {
            this.createQuoteGroup({ type: this.type, data: data })
              .then(resp => {
                this.$router.push({ name: `menu.quote.edit_${this.type}_quotes_group`, params: { id: resp.data.id } })
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.updateQuoteGroup({ id: this.formData.id, data: data })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  },
  watch: {
    'quoteGroupInstance': {
      deep: true,
      handler() {
        this.formData = this.quoteGroupInstance
      }
    }
  }
}
</script>
